<template>
  <v-app id="index-page">
    <dash-board-core-view />
  </v-app>
</template>

  <script>
    import DashBoardCoreView from './Components/View.vue';

    export default {
      name: 'DashboardIndex',

      components: {
        DashBoardCoreView,
      },

    };
  </script>
<style scoped>
#index-page{
  width: 100%;
  background: #ffffff;
}
</style>
